export default "__VITE_ASSET__DuojVaKs__"